import { useEffect, useRef, useState } from 'react';
import socketIO from 'socket.io-client';





const useReceptionSocket = (setSelectedPatient, patients, setPatients) => {

    const [patientChange , setPatientChange] =useState (0);


    const socketRef = useRef(null);

    useEffect(() => {
        socketRef.current = socketIO(process.env.REACT_APP_SERVICE_URL, {
            query: { clientId: "reception" }
        });

        socketRef.current.on("queueUpdate", (updatedAppointment) => {
            console.log("queue update", updatedAppointment);
            setPatients(patients =>
                patients
                    .map(patient => patient.ID === updatedAppointment.ID ? updatedAppointment : patient)
                    .filter(patient => patient.Tz != null)
            );
            setPatientChange(prev => prev + 1);
            if (updatedAppointment.Tz)
                setSelectedPatient(updatedAppointment);
        });

        socketRef.current.on("insertPatient", (newPatient) => {
            setPatients(prevPatients => [...prevPatients, newPatient]);
            console.log(patients);
            setPatientChange(prev => prev + 1);

        });

        socketRef.current.on("message", (message) => {
            console.log(message);
        });
        socketRef.current.on("deleteAllData", () => {
            window.location.reload()
        });


        return () => {
            socketRef.current.disconnect();
        };
    }, []);

    const moveRoom = (roomId, patientId, place) => {
        try {
            if (patientId == null)
                alert("אין מטופל");
            else {
                console.log("move client ", patientId, " to room ", roomId);
                socketRef.current.emit("moveClientToAnotherRoom", patientId, roomId, place,true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const emergencyAlertToDoctor = (patientId, roomId) => {
        try {
            if (patientId == null || roomId == null)
                alert("not valid");
            else {
                console.log("emergencyAlertToRoom", roomId, "for patient ", patientId);
                socketRef.current.emit("EmergencyAlertToRoom", roomId, patientId);
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    const endOfTreatment = (patientId) => {
        try {
            if (patientId != null) {
                socketRef.current.emit("deletePatient", patientId);
                console.log("end of treatment of patient: ", patientId);
            }
            else {
                alert("not valid");
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    const insertPatient = (firstName, LastName, HMO, tz, phone, room) => {
        try {
            console.log("room ", room);
            socketRef.current.emit("insertPatient", firstName, LastName, HMO, tz, phone, room);
            console.log("insert patient through socket");
        } catch (error) {

        }
    }

    const updateRoomList = () => {
        try {
            socketRef.current.emit("updateRoomList");
            console.log("update rooms list!!!");
        } catch (error) {
            console.log(error.message);
        }
    }
    const initAllSystem = () => {
        try {
            socketRef.current.emit("deleteAllData");
            console.log("init all system!!!");
        } catch (error) {
            console.log(error.message);
        }
    }

    return { moveRoom, emergencyAlertToDoctor, endOfTreatment, insertPatient,updateRoomList , patientChange ,initAllSystem};
};

export default useReceptionSocket;
